import React, { useEffect, useState } from "react";
import { getRemainingTimeFromNow } from "../common/dateOperations";
import styles from "./countdown.module.scss";

const Countdown: React.FC<{ endtime: Date }> = ({ endtime }) => {
    const [nr, setNr] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => { setNr(nr + 1); }, 1000);
        return () => clearInterval(timer);
    });

    return <span className={styles.timer}>{getRemainingTimeFromNow(endtime)}</span>;
};

export default Countdown;
